/**
 * Keyboard shortcut labels and ARIA values that follow the client device.
 */

import { detectDevice } from '@/utils/device-detection-utils';

/** Display label for a Ctrl/⌘ shortcut (`⌘K` on Apple, `Ctrl+K` elsewhere). */
export function formatShortcutLabel(key: string): string {
  const token = key.toUpperCase();
  return detectDevice().usesCommandKey ? `⌘${token}` : `Ctrl+${token}`;
}

/** WAI-ARIA keyshortcuts value matching {@link formatShortcutLabel}. */
export function formatShortcutAria(key: string): string {
  const token = key.toUpperCase();
  return detectDevice().usesCommandKey ? `Meta+${token}` : `Control+${token}`;
}
